import template   from './authentication.html'
import controller from './authentication.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/authentication/authentication.component.js